import React from 'react';

interface LoadingStateProps {
  message?: string;
  fullScreen?: boolean;
}

const LoadingState: React.FC<LoadingStateProps> = ({ message = "Loading...", fullScreen = false }) => {
  const containerClasses = fullScreen 
    ? "fixed inset-0 flex flex-col items-center justify-center bg-white dark:bg-gray-900 z-50"
    : "flex flex-col items-center justify-center p-12 w-full h-full min-h-[300px]";

  return (
    <div className={containerClasses}>
      <svg 
        className="animate-spin h-10 w-10 text-blue-600 dark:text-blue-400 mb-4" 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24"
      >
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4"
        ></circle>
        <path 
          className="opacity-75" 
          fill="currentColor" 
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
      <p className="text-gray-700 dark:text-gray-200 font-medium">{message}</p>
    </div>
  );
};

export default LoadingState;
